import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Idiomas.css';
import LogoSVG from '../Iconos/logo.svg';
import Anonimo from '../Imagenes/anonimo.webp';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import sumarIcon from '../Iconos/Sumar.svg';  // Ruta del icono Sumar.svg
import reloadIcon from '../Imagenes/reload.png';

const Idiomas: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [fotoPerfil, setFotoPerfil] = useState<string | null>(null);
  const [creditosRestantes, setCreditosRestantes] = useState<number | null>(null);
  const [creditosTotales, setCreditosTotales] = useState<number | null>(null);
  const [planActual, setPlanActual] = useState<string | null>(null);
  const [animationClass, setAnimationClass] = useState('');
  const [mostrarBocadillo, setMostrarBocadillo] = useState(false); // Estado para el bocadillo
  const history = useHistory(); // Hook para navegar a otra página

  // Manejar el toggle para mostrar u ocultar el bocadillo
  const handleToggleBocadillo = () => {
    setMostrarBocadillo(!mostrarBocadillo);
  };
  useEffect(() => {
    const fetchDatosPerfil = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
  
        // Obtener los créditos y el plan del usuario
        const creditosResponse = await axios.get(`${backendUrl}/creditos`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
  
        const datosCreditos = creditosResponse.data;
  
        setPlanActual(datosCreditos.plan || 'Sin plan');
        setCreditosRestantes(datosCreditos.creditosRestantes);
        setCreditosTotales(datosCreditos.creditosTotales);
  
        // Si los créditos son menores a 20, mostramos el bocadillo
        if (datosCreditos.creditosRestantes < 20) {
          setMostrarBocadillo(true);
        }
  
        // Obtener la foto de perfil
        const fotoResponse = await axios.get(`${backendUrl}/perfil/recogerfoto`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          responseType: 'blob'
        });
        const imageUrl = URL.createObjectURL(fotoResponse.data);
        setFotoPerfil(imageUrl);
      } catch (error) {
        console.error('Error al recuperar los datos del perfil y créditos:', error);
      }
    };
  
    // Ejecutar la función inmediatamente al montar el componente
    fetchDatosPerfil();
  
    // Crear un intervalo para ejecutar fetchDatosPerfil cada 5 segundos
    const intervalId = setInterval(fetchDatosPerfil, 5000);
  
    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(intervalId);
  }, []);
  

  useEffect(() => {
    if (creditosRestantes !== null) {
      setAnimationClass('creditos-animation');
      setTimeout(() => setAnimationClass(''), 500); // Limpiar la clase de animación después de 500 ms
    }
  }, [creditosRestantes]);

  const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(event.target.value);
  };

  const cerrarBocadillo = () => {
    setMostrarBocadillo(false); // Cierra el bocadillo cuando se hace clic en la 'x'
  };

  const handleRenovarCreditos = () => {
    // Redirigir a la sección de planes en el perfil
    history.push('/PerfilPage?section=MiPlan');
    setTimeout(() => {
      document.getElementById('MiPlan')?.scrollIntoView({ behavior: 'smooth' }); // Navega a la sección de Planes
    }, 300);
  };

  return (
    <div className='perfil-container'>
      <nav>
        <ul>
          <div className="perfil-subcontainer">
            {fotoPerfil ? (
              <img src={fotoPerfil} alt="Foto de perfil" className="profile-picture" />
            ) : (
              <img src={Anonimo} alt="Chat Icon" className="profile-picture" />
            )}
            <li className='perfil-navbar'><a href="/PerfilPage">{t('Perfil')}</a></li>
          </div>
          {/* Mostrar información del plan actual y créditos */}
          <div className={`creditos-container ${animationClass}`}>
            <p style={{ color: creditosRestantes !== null && creditosRestantes < 20 ? 'red' : 'inherit' }}>
              {t('Créditos')}: {creditosRestantes} / {creditosTotales}
            </p>

            {/* Botón para desplegar el bocadillo */}
            <button className="sumar-btn" onClick={handleToggleBocadillo}>
              <img src={sumarIcon} alt="Sumar Icono" />
            </button>
          </div>

          {/* Mostrar el bocadillo si los créditos son bajos o si el usuario hace clic en el botón */}
          {mostrarBocadillo && (
            <div className="bocadillo-renueva-creditos">
              <p>{t('Renueva tus créditos:')}</p>
              <button className="btn-renueva" onClick={handleRenovarCreditos}><img src={reloadIcon} alt="" />Renovar</button>
            </div>
          )}

          <li className="idiomas-container">
            <select className="idiomas" onChange={changeLanguage} defaultValue={i18n.language}>
              <option value="es">Español</option>
              <option value="en">Inglés</option>
              <option value="de">Alemán</option>
            </select>
          </li>
        </ul>
      </nav>


    </div>
  );
};

export default Idiomas;
